import Action from '../actions'

export function publicSysConfigReducer(state = [], action) {
    if (action.type === Action.PUBLIC_SYSTEM_CONFIGURATION) {
        return action.sysConfig;
    }
    return state;
}
